import { render, staticRenderFns } from "./orders-mass-status-changer.vue?vue&type=template&id=0021896a&scoped=true"
import script from "./orders-mass-status-changer.vue?vue&type=script&lang=js"
export * from "./orders-mass-status-changer.vue?vue&type=script&lang=js"
import style0 from "./orders-mass-status-changer.vue?vue&type=style&index=0&id=0021896a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0021896a",
  null
  
)

export default component.exports